import { api } from '@/api'
import { DASHBOARD_URL } from '@/env'
import { getUtmParams } from '@/utils/utmParams'

export interface AuthResponse {
  token: string
}

export interface MagicLinkRequestResponse {
  message: string
}

export const authService = {
  loginWithGoogleCode: (code: string, redirectUri: string) =>
    api.post<AuthResponse>('/auth/login/google', {
      code,
      redirectUri,
      ...getUtmParams()
    }),
  loginWithGoogleCredential: (credential: string) =>
    api.post<AuthResponse>('/auth/login/google', {
      credential,
      ...getUtmParams()
    }),
  requestMagicLink: (email: string, inviteCode?: string | null) =>
    api.post<MagicLinkRequestResponse>('/auth/magic-link/request', {
      email,
      inviteCode: inviteCode || undefined,
      redirectUrl: `${DASHBOARD_URL}/auth`,
      ...getUtmParams()
    }),
  verifyMagicLink: (token: string) =>
    api.post<AuthResponse>('/auth/magic-link/verify', {
      token,
      ...getUtmParams()
    })
}
